module.exports = __webpack_public_path__ + "static/media/gg.218797b3.svg";